import { useEffect, useRef, useState } from "react";
import { Checkbox, ComboBox, DefaultButton, Dialog, DialogType, IComboBoxOption, Label, PrimaryButton, Stack, TextField } from "@fluentui/react";
import styles from '../styles/pokemon.module.scss';
import { TConfig, TSet } from "../constants/types";
import { ObjectArraysEqual } from "../services/Globals";

export interface ISettingsProps {
    Sets : TSet[];
    site: string;
    username: string;
    token :string;
    apiUrl: string;
    setMessage: Function;
    setError: Function;
}

const Settings : React.FunctionComponent<ISettingsProps> = (props : ISettingsProps) => {
    const [BUYCOMPLETECOLLECTION, setBUYCOMPLETECOLLECTION] = useState<boolean>(false);
    const [CONFIG_BUYCOMPLETECOLLECTION, setCONFIG_BUYCOMPLETECOLLECTION] = useState<TConfig>();

    const [BUYCOMPLETECOLLECTIONDISCOUNT, setBUYCOMPLETECOLLECTIONDISCOUNT] = useState<number>(0);
    const [CONFIG_BUYCOMPLETECOLLECTIONDISCOUNT, setCONFIG_BUYCOMPLETECOLLECTIONDISCOUNT] = useState<TConfig>();

    const [BUYCOMPLETESET, setBUYCOMPLETESET] = useState<boolean>(false);
    const [CONFIG_BUYCOMPLETESET, setCONFIG_BUYCOMPLETESET] = useState<TConfig>();

    const [BUYCOMPLETESETDISCOUNT, setBUYCOMPLETESETDISCOUNT] = useState<number>(0);
    const [CONFIG_BUYCOMPLETESETDISCOUNT, setCONFIG_BUYCOMPLETESETDISCOUNT] = useState<TConfig>();

    useEffect(() => {
            fetch(`${props.apiUrl}/GetConfig?username=${props.username}&token=${props.token}&site=${props.site}`, {
                method: 'GET',
                mode: 'cors',
            }).then((response) => response.json()).then((data: TConfig[]) => {
                data.forEach((d) => {
                    switch (d.name) {
                        case "BUYCOMPLETECOLLECTION":
                            setCONFIG_BUYCOMPLETECOLLECTION(d);
                            setBUYCOMPLETECOLLECTION(d.value === "1" ? true : false);
                            break;
                        case "BUYCOMPLETECOLLECTIONDISCOUNT":
                            setCONFIG_BUYCOMPLETECOLLECTIONDISCOUNT(d);
                            setBUYCOMPLETECOLLECTIONDISCOUNT(+d.value);
                            break;
                        case "BUYCOMPLETESET":
                            setCONFIG_BUYCOMPLETESET(d);
                            setBUYCOMPLETESET(d.value === "1" ? true : false);
                            break;
                        case "BUYCOMPLETESETDISCOUNT":
                            setCONFIG_BUYCOMPLETESETDISCOUNT(d);
                            setBUYCOMPLETESETDISCOUNT(+d.value);
                            break;
                        default:
                            break;
                    }
                })
            }).catch(err => {
                console.log(err);
            });
    
            window.scrollTo(0, 0);
        }, []);

    function save() {
        let newConfigs: TConfig[] = [];

        if ((CONFIG_BUYCOMPLETECOLLECTION.value === "1" ? true : false) !== BUYCOMPLETECOLLECTION) {
            newConfigs.push({ id: CONFIG_BUYCOMPLETECOLLECTION.id, name: CONFIG_BUYCOMPLETECOLLECTION.name, value: BUYCOMPLETECOLLECTION ? "1" : "0" });
        }
        if (CONFIG_BUYCOMPLETECOLLECTIONDISCOUNT.value !== BUYCOMPLETECOLLECTIONDISCOUNT.toString()) {
            newConfigs.push({ id: CONFIG_BUYCOMPLETECOLLECTIONDISCOUNT.id, name: CONFIG_BUYCOMPLETECOLLECTIONDISCOUNT.name, value: BUYCOMPLETECOLLECTIONDISCOUNT.toString() });
        }
        if ((CONFIG_BUYCOMPLETESET.value === "1" ? true : false) !== BUYCOMPLETESET) {
            newConfigs.push({ id: CONFIG_BUYCOMPLETESET.id, name: CONFIG_BUYCOMPLETESET.name, value: BUYCOMPLETESET ? "1" : "0" });
        }
        if (CONFIG_BUYCOMPLETESETDISCOUNT.value !== BUYCOMPLETESETDISCOUNT.toString()) {
            newConfigs.push({ id: CONFIG_BUYCOMPLETESETDISCOUNT.id, name: CONFIG_BUYCOMPLETESETDISCOUNT.name, value: BUYCOMPLETESETDISCOUNT.toString() });
        }

        if (newConfigs.length) {
            fetch(`${props.apiUrl}/SetConfig`, {
                method: "Post",
                mode: "cors",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "Accept-Encoding": "gzip, deflate ,br"
                },
                referrerPolicy: "origin-when-cross-origin",
                body: JSON.stringify({ token: props.token, username: props.username, site: props.site, items: newConfigs }),
            }).then((response) => response.json()).then((data) => data).then((success: boolean) => {
                if (success) {
                    props.setMessage("Nieuwe instellingen opgeslagen.");
                } else {
                    props.setError("Opslag instellingen gefaald.");
                }
            }).catch((ex) => {
                props.setError(ex);
            });
        }
    }

    return (
        <Stack horizontal style={{margin:10, display: window.innerWidth > 950 ? "flex":"block"}}>
            <Stack tokens={{childrenGap:10}}>
                <Checkbox label="Laat mogelijkheid zien om volledige collectie in zijn geheel te kopen zien" 
                          checked={BUYCOMPLETECOLLECTION}
                          onChange={() => {setBUYCOMPLETECOLLECTION(!BUYCOMPLETECOLLECTION);}}
                />
                <TextField label="Korting" 
                           value={BUYCOMPLETECOLLECTIONDISCOUNT.toString()} 
                           type="number" 
                           min="0"
                           max="90"
                           suffix="%"
                           onChange={(e,v) => { setBUYCOMPLETECOLLECTIONDISCOUNT(+v < 91 ? +v : BUYCOMPLETECOLLECTIONDISCOUNT);}} />
                <hr />
                <Checkbox label="Laat mogelijkheid zien om een set (categorie) in zijn geheel te kopen zien" 
                          checked={BUYCOMPLETESET} 
                          onChange={() => {setBUYCOMPLETESET(!BUYCOMPLETESET);}}
                />
                <TextField label="Korting" 
                           value={BUYCOMPLETESETDISCOUNT.toString()} 
                           type="number" 
                           min="0"
                           max="90" 
                           suffix="%"
                           onChange={(e,v) => { setBUYCOMPLETESETDISCOUNT(+v < 91 ? +v : BUYCOMPLETESETDISCOUNT); }} />
                <hr />
                <PrimaryButton text="Opslaan in site"  onClick={save}/>
            </Stack>
        </Stack>
    );
}

export default Settings;